<div class="py-2 px-3">
    <h1 mat-dialog-title class="sub-header-title">Delete {{ data }}</h1>
    <div mat-dialog-content class="my-3">
        <div>Please confirm you would like to delete this {{ data }}?</div>
        <div>This action cannot be undone.</div>
    </div>
    <div mat-dialog-actions class="justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
            Cancel
        </button>
        <button mat-raised-button class="warn-button" (click)="onDeleteClick()">
            Delete
        </button>
    </div>
</div>